import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env/pePro/environment';
import { IonicModule } from '@ionic/angular';
import { LoginModule } from '@lib/login/login.module';
import { SharedModule } from '@lib/shared';
import * as Sentry from '@sentry/angular';
import { Angulartics2Module } from 'angulartics2';
import { CoreModule } from 'lib/core';
import { MomentModule } from 'ngx-moment';
import { QuillModule } from 'ngx-quill';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './home/home.module';
import { LicenceExpiredModule } from '@lib/licence-expired/licence-expired.module';
import { SettingsModule } from '@lib/settings/settings.module';
import { ShellModule } from './pe-pro-shell/pe-pro-shell.module';
import { ShellModule as ShellOutdoorProModule } from '@app/outdoorPro/shell/shell.module';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideEkcFirebase } from '@lib/core/firebase.providers';
import { initializeFirebasePerformance } from '@lib/core/firebase-performance-init';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
    IonicModule.forRoot(),
    CoreModule,
    SharedModule,
    ShellModule,
    ShellOutdoorProModule,
    HomeModule,
    SettingsModule,
    LoginModule,
    LicenceExpiredModule,
    FormsModule,
    ReactiveFormsModule,
    QuillModule.forRoot(),
    Angulartics2Module.forRoot(),
    MomentModule,
    Sentry.TraceModule,
    AppRoutingModule,
  ],
  providers: [
    provideEkcFirebase({
      firebase: environment.firebase,
      functionsRegion: 'europe-west1',
      remoteConfigDefaults: {},
      useEmulators: environment.useEmulators,
    }),
    provideIonicAngular(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const initializerFn = ((traceService) => () => {})(inject(Sentry.TraceService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      initializeFirebasePerformance();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
